module.exports = __webpack_public_path__ + "img/dentalfit_6_b.269f3a71.jpg";